module.exports = __webpack_public_path__ + "static/img/agent_banner1.1b14b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/agent_banner1.png
// module id = NiVX
// module chunks = 1